<template>
  <div v-loading="loading" class="card">
    <div class="flex justify-between">
      <div class="group-options-select">
        <div class="flex">
          <div class="mr-2 p-2 px-3 filter cursor-pointer hover:shadow-sm" :class="{ 'shadow-sm': sortList }"
            @click="sortList = !sortList">
            <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
          </div>

          <div class="table__search-input-wrapper">
            <span class="pr-2 opacity-50">
              <search-icon />
            </span>
            <input type="text" class="table__search-input" placeholder="Search..." v-model="queryString" />
            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>
        </div>
      </div>
      <primary-button @click="showAddTaxModal = true" buttonText="Add New Tax" />
    </div>

    <div class="responsive-table">
      <el-collapse v-model="activeTax" @change="handleChange">
        <el-collapse-item :name="tax" class="accordion" v-for="(tax, index) in arrangedTaxes" :key="index">
          <template slot="title">
            <div class="flex justify-between w-100">
              <span class="font-bold">{{ tax }}, {{ formattedTaxes[tax][0].country }} ({{
                  formattedTaxes[tax].length
              }})</span>
              <span class="font-bold">Cumulative Rate:
                {{
                    formattedTaxes[tax]
                      .map((tax) => {
                        return parseInt(tax.rate);
                      })
                      .reduce((a, b) => a + b, 0)
                }}%</span>
            </div>
          </template>
          <table class="custom-table responsive-table border-collapse">
            <thead>
              <tr>
                <th>Tax Authority</th>
                <th>Authority Code</th>
                <th>Label</th>
                <th>Rate(%)</th>
                <th>TIN</th>
                <th>eRemittance</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="formattedTaxes[tax].length == 0">
              <tr class="shadow-md rounded-lg">
                <td colspan="4">
                  <div class="flex flex-col justify-center items-center gap-4">
                    <empty-tax-icon />
                    <p>No Tax to display.</p>
                    <div class="flex gap-2 text-primary-yellow text-center text-sm font-bold cursor-pointer"
                      @click="isRemittanceModal = true">
                      <span>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="#FCC210"
                          xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11.5 22.3672C5.42487 22.3672 0.5 17.4423 0.5 11.3672C0.5 5.29206 5.42487 0.367188 11.5 0.367188C17.5751 0.367188 22.5 5.29206 22.5 11.3672C22.5 17.4423 17.5751 22.3672 11.5 22.3672ZM11.5 20.3672C16.4706 20.3672 20.5 16.3378 20.5 11.3672C20.5 6.39662 16.4706 2.36719 11.5 2.36719C6.52944 2.36719 2.5 6.39662 2.5 11.3672C2.5 16.3378 6.52944 20.3672 11.5 20.3672ZM16.5 10.3672H12.5V6.36719H10.5V10.3672H6.5V12.3672H10.5V16.3672H12.5V12.3672H16.5V10.3672Z"
                            fill="#FCC210" />
                        </svg>
                      </span>
                      Start Adding Tax
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr v-for="(ta, index) in formattedTaxes[tax]" :key="index" class="shadow-md rounded-lg">
                <td>{{ ta.authority }}</td>
                <td>{{ ta.code }}</td>
                <td>{{ ta.label }}</td>
                <td>{{ ta.rate }}%</td>
                <td>
                  {{ ta.tin }}
                </td>
                <td>
                  <span :class="{
                    enabled: ta.isRemittanceEnabled,
                    disabled: !ta.isRemittanceEnabled,
                  }">
                    {{ ta.isRemittanceEnabled }}</span>
                </td>

                <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer">
                  <span class="d-flex justify-content-center align-items-center" @click="showActionOptions(ta.id)">
                    <vertical-ellipsis />
                  </span>
                  <div class="table__action-options" v-if="selectedRowId == ta.id">
                    <div class="table__action-option cursor-pointer" @click="editTin(ta, tax)">
                      <p>Edit</p>
                    </div>
                    <div @click="showDeleteModal(ta.id)" class="table__action-option cursor-pointer">
                      <p>Delete</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </el-collapse-item>
      </el-collapse>
    </div>
    <pagination-control />

    <tax-remittance-modal :showModal="isRemittanceModal" @close-modal="isRemittanceModal = false" />

    <new-tax-modal :show-modal="showAddTaxModal" @created="getTAllTax" @close-modal="showAddTaxModal = false" />
    <edit-tax-modal :show-modal="showEditTaxModal" @close-modal="showEditTaxModal = false" @updated="getTAllTax"
      :tax="taxTobeEdited">
    </edit-tax-modal>

    <delete-modal :showModal="isDeleteModal" :itemToDelete="itemToDelete" :deletingItem="deleteingTax"
      @close-modal="isDeleteModal = false" @delete-item="removeTin" />
  </div>
</template>

<script>
import PaginationControl from "@/components/UI/NewPagination";
import TaxRemittanceModal from "./TaxRemittanceModal";
import NewTaxModal from "@/components/3pl/Settings/LocationAndTax/Tax/Modals/NewTaxModal";
import EditTaxModal from "@/components/3pl/Settings/LocationAndTax/Tax/Modals/EditTaxModal";

export default {
  components: {
    PaginationControl,
    TaxRemittanceModal,
    NewTaxModal,
    EditTaxModal,
  },
  data() {
    return {
      selectedRowId: null,
      isRemittanceModal: false,
      deleteingTax: false,
      allTaxAuthorities: [],
      loading: false,
      selectedTaxAuthorityId: "",
      tinValue: "",
      taxAuthoritiesWithTins: [],
      filteredTaxAuthorities: [],
      taxAuthoritiesCopy: [],
      unduplicatedTaxAuthorities: [],
      found: false,
      editedTinId: null,
      editedTinValue: "",
      queryString: "",
      itemToDelete: "Tax",

      activeTax: 1,
      taxes: [],
      formattedTaxes: [],
      showAddTaxModal: false,
      showEditTaxModal: false,
      taxTobeEdited: {},
      sortList: false,
      selectedTaxId: null,
      isDeleteModal: false,
    };
  },
  computed: {
    queriedTaxAuthorities() {
      return this.filterArray(this.taxes, this.queryString);
    },

    arrangedTaxes() {
      if (this.sortList) {
        return Object.keys(this.formattedTaxes).sort((a, b) => {
          var x = a.toLowerCase();
          var y = b.toLowerCase();
          return x < y ? -1 : x > y ? 1 : 0;
        });
      } else {
        return Object.keys(this.formattedTaxes);
      }
    },
  },
  mounted() {
    this.getTAllTax();
  },
  methods: {
    handleChange() { },

    async getTAllTax() {
      this.loading = true;
      this.taxes = [];

      try {
        let response = await this.$_getAllTax();
        this.taxes = response.data.data;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },

    showDeleteModal(taxId) {
      this.selectedTaxId = taxId;
      this.isDeleteModal = true;
    },

    editTin(tax, state) {
      this.taxTobeEdited = {
        ...tax,
        state: state,
      };
      this.showEditTaxModal = true;
    },

    async removeTin() {
      this.deleteingTax = true;
      try {
        await this.$_deleteTax(this.selectedTaxId);
        this.generateToast("Tax successfully deleted!", "success");
        this.getTAllTax();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.deleteingTax = false;
        this.isDeleteModal = false;
      }
    },

    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
  watch: {
    queriedTaxAuthorities: {
      deep: true,
      immediate: true,
      handler() {
        if (this.queriedTaxAuthorities.length > 0) {
          const groupByKey = (list, key, { omitKey = false }) =>
            list.reduce(
              (hash, { [key]: value, ...rest }) => ({
                ...hash,
                [value]: (hash[value] || []).concat(
                  omitKey ? { ...rest } : { [key]: value, ...rest }
                ),
              }),
              {}
            );
          this.formattedTaxes = groupByKey(this.queriedTaxAuthorities, "state", {
            omitKey: true,
          });
        }
      },
    },
  },
};
</script>

<style>
.enabled {
  background: #09b78a1a;
  color: #09b78a;
  padding: 8px 25px;
  border-radius: 4px;
  text-transform: capitalize;
}

.disabled {
  background: #e433421a;
  color: #d72638;
  padding: 8px 25px;
  border-radius: 4px;
  text-transform: capitalize;
}

.el-collapse-item__arrow {
  order: -1;
}

.accordion {
  box-shadow: 0px 1px 2px rgba(45, 49, 66, 0.06), 0px 1px 3px rgba(8, 7, 8, 0.1);
  padding: 0.5rem 1rem 0;
  margin: 1rem 0;
  border-radius: 0.5rem;
}

.table-wrapper {
  margin: 3rem 0;
}

.table-header {
  display: flex;
  justify-content: flex-end;
}

.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}

.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}

.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}

.table__search-input:focus {
  outline: none;
}

.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}

.custom-table {
  /* margin: 2rem 0; */
  width: 100%;
}

.custom-table th {
  color: #060e18;
  font-weight: 600;
}

.custom-table th,
td {
  padding: 1rem;
  font-size: 0.9rem;
}

.custom-table td {
  color: #343633;
}

.table__action-btn {
  position: relative;
  padding: 0;
}

.table__action-options {
  position: absolute;
  width: 8rem;
  padding: 0.5rem 0;
  right: 2rem;
  background: #ffffff;
  z-index: 999;
  border-radius: 3px;
  box-shadow: 0px 0px 12px #dee0e7;
}

.table__action-option {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}

.table__action-option:hover {
  background: #fce4da;
}

.table__action-btn span {
  width: 100%;
}

/* .input {
  height: 1.75rem;
  width: 10vw;
} */
</style>
